module.exports = __webpack_public_path__ + "img/symbol_9.204092c4.png";